import { Component, Input, OnInit } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { AccessibilityDialogsNewHelpCenterDecisionTreeComponent } from './decision-tree/decision-tree.component';
import { SupportAccessibilityCheckService } from '@client/app/modules/supportcenter/services/entities/accessibility-check/accessibility-check.service';
import { AccessibilityDialogsHelpCenterService } from './new-help-center.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import {
    SupportAccessibilityChecksRepoGetAllType,
} from '@client/app/modules/supportcenter/services/api/accessibility-checks/support-accessibility-checks-repo.service';

type AccessibilityCheckTag = {
    translation: string,
    class: string
};

@Component({
    selector: 'accessibility-dialogs-new-help-center',
    templateUrl: './new-help-center.component.html',
    standalone: false,
})
export class AccessibilityDialogsNewHelpCenterComponent implements OnInit {
    @Input() check!: any;

    supportCenterCheck: SupportAccessibilityChecksRepoGetAllType | null = null;
    decisionTree: any = null;
    loading = false;
    getDifficultyTranslation: string = '';
    tags: AccessibilityCheckTag[] = [];
    guidelines: string[] = [];

    constructor (
        private supportAccessibilityCheckService: SupportAccessibilityCheckService,
        private accessibilityDialogsHelpCenterService: AccessibilityDialogsHelpCenterService,
        private monEventService: MonEventService,
    ) {}

    ngOnInit (): void {
        this.supportCenterCheck = null;
        this.decisionTree = null;
        this.getDecisionTree();
        this.getPage();
    }

    setTypeColor (): string {
        let result = 'info';
        if (this.check.issue_abbr === 'A') {
            result = 'wcag-a';
        } else if (this.check.issue_abbr === 'AA') {
            result = 'wcag-aa';
        } else if (this.check.issue_abbr === 'AAA') {
            result = 'wcag-aaa';
        }
        return result;
    }

    openDecisionTree (): void {
        const params = {
            body: AccessibilityDialogsNewHelpCenterDecisionTreeComponent,
            size: 'xs',
            data: {
                decisionTree: this.decisionTree,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    canUseDecisionTree (): boolean {
        return this.decisionTree !== null;
    }

    showSection (str: string): boolean {
        return typeof str === 'string' && str.length > 0 && !str.includes('N/A');
    }

    private getPage (): void {
        const params = {
            check_id: this.check.id,
        };
        this.loading = true;
        this.supportAccessibilityCheckService.getAll(params)
            .then((supportCenterAccessibilityCheck: any[]) => {
                if (supportCenterAccessibilityCheck.length > 0) {
                    this.supportCenterCheck = supportCenterAccessibilityCheck[0];
                    if (!this.supportCenterCheck) {
                        return;
                    }
                    this.tags = this.supportCenterCheck.tags.map((tag: any) => {
                        return {
                            translation: this.accessibilityDialogsHelpCenterService.getTagTranslation(tag),
                            class: this.accessibilityDialogsHelpCenterService.getTagClass(tag),
                        };
                    });

                    this.getDifficultyTranslation = this.accessibilityDialogsHelpCenterService.getDifficultyTranslation(this.supportCenterCheck.difficulty);
                    this.guidelines = this.supportCenterCheck.guidelines || [];
                }
            })
            .catch(() => {
                // Handle error
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private getDecisionTree (): void {
        this.supportAccessibilityCheckService.getDecisionTree(this.check).then((decisionTree: any) => {
            this.decisionTree = decisionTree;
        }).catch(() => {
            // Handle error
        });
    }
}
